<template>
  <b-img
    fluid
    src="@/assets/images/logo/logo.gif"
    alt="Login V2"
    :width="width"
  />
</template>

<script>
import {
  BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BImg,
  },
  props: {
    width: {
      type: String,
      default: "300"
    }
  },
  
  data() {
    return {
      imgUrl: '@assets/images/logo/exxtra.png',
    }
  },
}
</script>
